{
  "yes": "예",
  "no": "아니오",
  "add": "추가",
  "add.confirm": "추가 하시겠습니까?",

  "confirm": "확인",
  "delete.confirm": "삭제 하시겠습니까?",

  "update.complete": "변경되었습니다.",

  "msg.delete.confirm": "삭제 하시겠습니까?",
  "msg.copy.confirm": "복사 하시겠습니까?",

  "captain.quick": "퀵대장",
  "QUICK": "퀵대장",
  "captain.meal": "식권대장",
  "SIKDAE": "식권대장",
  "captain.flower": "꽃대장",
  "captain.mro": "비품대장",
  "WELFARE": "복지대장",
  "captain.welfare": "복지대장",
  "captain.benefits": "혜택",
  "captain.education": "의무교육대장",
  "captain.ezwel": "복지대장몰",

  "service.use.apply": "서비스 사용 신청",
  "service.use.applying": "서비스 사용 신청중",
  "service.use.apply.complete": "서비스 사용 신청완료",
  "service.agreement": "서비스 이용 동의",
  "service.agreement.history": "서비스 이용 동의 현황",
  "service.agreement.disabled": "서비스 이용 안함",
  "service.use.sikdae": "식권대장 이용을 위해선, 벤디스 담당자 혹은 고객센터(1644-5047)을 통해 먼저 상의해주시길 바랍니다.",
  "service.agreement.complete.text": "서비스 이용 동의 완료",
  "service.agreement.history.desc": "대장마켓플레이스의 각 서비스에 대한 이용 동의 현황과 약관을 확인 하실 수 있습니다.",
  "service.agreement.complete": "현재 서비스 이용 동의후, 서비스 이용 중입니다.",
  "service.agreement.pause": "현재 서비스 이용 동의후, 서비스 일시 중지 중입니다.",
  "quick.service.use.status": "서비스 이용 상태",
  "quick.agreenment.user": "이용동의 사용자",
  "quick.agreement.date": "이용동의 일시",
  "info.change.inquiry": "※ 정보 변경은 벤디스 담당자에게 문의해주세요.",

  "service.update.date": "사용 중지 및 재개 날짜",
  "service.update.user": "사용 중지 및 재개 사용자",
  "quick.agreement.detail": "이용동의 내용",
  "address.alias.required": "주소 별명을 입력해 주세요.",
  "use.name.required": "이름을 입력해 주세요.",
  "use.cell.required": "연락처를 입력해 주세요.",

  "save": "저장",
  "desc": "설명",
  "use.terms": "이용 약관",
  "inuse": "사용중",
  "disabled": "이용 안함",
  "notinuse": "일시 중지중",
  "stop.using": "일시 중지",
  "start.using": "일시 중지 해제",
  "3rd.info.supply": "제3자 정보 제공",
  "pdf.download.info": "(클릭시, PDF로 다운로드 됩니다.)",
  "pause": "일시정지",
  "address.manage": "주소관리",
  "address.book": "주소록",
  "quick.reservation": "퀵 예약하기",
  "quick.reservation.edit": "퀵 예약 수정하기",
  "quick.reservation.detail": "퀵 예약 상세",
  "quick.reservation.list": "예약 및 내역",

  "input.search.placeholder": "검색어 입력",
  "regist.number": "접수 번호",
  "reservation.user.name": "예약자",
  "sender.name": "보내는 분 이름",
  "receiver.name": "받는 분 이름",
  "product.info": "물품 정보",
  "product.size": "물품 크기",
  "product.size.desc": "물품 정보를 입력해주세요. (예. 10*10*10 소형 10kg 5박스 입니다.) (최대 70자 입력 가능)",
  "product.size.vehicle": "다마스 이상 (물품에 따라 자동으로 결정됩니다.)",
  "product.size.vehicle.bike": "오토바이 (물품에 따라 자동으로 결정됩니다.)",
  "product.size.documents": "물품 크기 : 최대 크기 : 30*30*30 cm 미만 / 최대 중량 : 20kg 미만",
  "product.size.smallbox": "물품 크기 : 최대 크기 : 30*30*30 cm 미만 / 최대 중량 : 20kg 미만",
  "product.size.bigbox": "물품 크기 : 최대 크기 : 50*50*50 cm 미만 / 최대 중량 : 20kg 미만",
  "product.size.others": "물품 크기 : 오토바이에 실을수 있는 품목 / 최대 중량 : 20kg 미만",
  "product.size.genralfreight": "오토바이 적재 불가 상품",
  "product.cnt.documents": "최대 20개까지 가능",
  "product.cnt.smallbox": "최대 2개까지 가능",
  "product.cnt.bigbox": "최대 1개까지 가능",
  "product.cnt.others": "오토바이에 실을 수 있는 품목만 가능",
  "mobile.product.size.documents": "30*30*30 cm 미만 / 최대 중량 : 20kg 미만",
  "mobile.product.size.smallbox": "30*30*30 cm 미만 / 최대 중량 : 20kg 미만",
  "mobile.product.size.bigbox": "50*50*50 cm 미만 / 최대 중량 : 20kg 미만",
  "mobile.product.size.others": "오토바이에 실을 수 있는 품목 / 최대 중량 : 20kg 미만",
  "freight": "화물크기 및 중량",
  "confirm.price": "확정 운임",
  "pickup.date": "픽업 일시",
  "reservation.date": "예약 일시",
  "status": "상태",
  "status.changed.date": "상태 변경 일시",
  "count": "개수",
  "quantity": "수량",
  "quick.add": "퀵 추가 이용하기",
  "reservation.modify": "예약 수정",
  "reservation.cancel": "예약 취소",
  "reservation.cancel.confirm": "예약을 취소하시겠습니까?",
  "reservation.default.info": "예약 기본 정보",
  "reservation.number": "예약 번호",
  "reservation.user": "예약자",
  "delivery.status": "배송 상태",
  "reservation.detail.info": "예약 상세 정보",
  "delivery.info": "운임 정보",
  "delivery.alert.message1": "퀵 예약 후 발생하는 모든 문의사항은 고고엑스 CS(1588-3047) 로 문의해 주시길 바랍니다.",
  "delivery": "예상 운임",
  "reservation.content": "예약 내용",
  "confirm.message": "위 내용을 확인하였습니다.",
  "agreement.notice": "유의 사항 확인 및 동의",
  "agreement.privacy": "개인 정보 수집 및 이용 동의",

  "reservationNumber": "예약번호",
  "reservationUser": "예약자",
  "reservationDate": "예약 일시",
  "confirmPrice": "확정 운임",
  "vehicle.kind": "차량 종류",
  "vehicle": "차량",
  "product.vehicle.info": "물품 및 차량 정보",
  "quick.startpoint": "보내는 분",
  "quick.waypoint.user": "경유자",
  "quick.waypoint": "경유지",
  "quick.endpoint": "받는 분",
  "quick.pickup.time": "픽업 시간",
  "quick.etc": "특이사항",
  "quick.send.memo": "배송 메모",
  "id": "아이디",
  "management": "관리",
  "logout": "로그아웃",
  "logout.force": "강제로그아웃",
  "complete": "완료",
  "cancel": "취소",
  "close": "닫기",
  "quick.etc.info": "부가정보",

  "quick.slogan": "내가 찾던 비지니스 퀵, 퀵대장",
  "quick.slogan.desc.01": "배송과정 확인부터 이용내역 조회, 간편 정산까지",
  "quick.slogan.desc.02": "이제 한눈에 보고 한 번에 처리하세요.",
  "start.button": "지금 시작하기",
  "quick.start.button": "퀵대장 시작하기",
  "1:1": "1:1 문의",
  "quick.exist.mid": "경유지가 있는 경우, 체크해주세요",
  "quick.fast": "급송",

  "weather": "날씨",
  "date": "날짜",
  "quick.complete.count": "퀵 완료 횟수",
  "amount.total": "운임 총합",
  "quick.require.carrier": "운반 필요",
  "quick.require.carrier.help": "물품 운반 도움 요청",
  "quick.company.passenger": "승객 동승",

  "quick.address.alias.placeholder": "주소 별명을 입력해주세요",
  "quick.address.save.help": "입력한 주소를 주소록에 등록하겠습니다.",

  "goods.cnt.required": "개수을 입력해 주세요.",
  "goods.info.required": "물품 정보를 입력해 주세요.",
  "start.address.required": "출발지를 입력해 주세요.",
  "way.address.required": "경유지를 입력해 주세요.",
  "end.address.required": "도착지를 입력해 주세요.",
  "pickup.info.required": "픽업 시간 및 부가정보를 입력해 주세요.",
  "goods.size.required": "화물크기 및 중량을 선택해 주세요.",
  "goods.type.required": "물품 크기를 선택해 주세요",
  "quick.pickup.required": "픽업시간은 현재 시간 기준 20분 후의 시간으로 설정해주세요.",
  "quick.address.required": "주소 정보를 입력해 주세요.",

  "quick.address.alias": "주소 별명",
  "quick.address.detail": "주소 상세",
  "quick.predict.price": "예상 운임 확인",
  "quick.memo": "메모",
  "quick.memo.help": "요청 사항을 입력해주세요. (최대 70자 입력 가능)",
  "quick.address.info": "주소 정보",
  "quick.address.search": "주소 검색",
  "quick.address.add": "주소 추가",
  "quick.address.add.success": "주소 추가가 완료되었습니다.",
  "quick.address": "주소",
  "user.name": "이름",
  "user.name.placeholder": "이름을 입력해 주세요.",
  "user.contact": "연락처",
  "user.contact.placeholder": "연락처를 입력해주세요",
  "user.registered.date": "사용자 생성일",
  "user.recent.modified": "최근 수정 사용자",
  "user.recent.modified.date": "최근 수정 일시",
  "user.signId.placeholder": "6자 이상 40자 이하로 입력해주세요.",
  "user.password": "비밀번호",
  "user.password.placeholder": "4자 이상 입력해주세요.",
  "user.password.confirm": "비밀번호 재입력",
  "user.password.confirm.placeholder": "동일한 비밀번호를 입력해주세요.",
  "user.password.confirm.help": "생성된 사용자는 최초 로그인시, 반드시 비밀번호 재설정 과정을 거치게 됩니다.",
  "user.password.notify": "생성된 상용자는 최초 로그인시, 반드시 비밀번호 재설정 과정을 거치게 됩니다.",
  "user.email": "이메일",
  "user.email.placeholder": "@포함 50자 이하로 입력해주세요.",
  "user.cell": "휴대전화번호",
  "user.cell.placeholder": "- 구분 없이 입력해주세요.",
  "user.status": "사용자 상태",
  "user.dormant": "휴면 상태",
  "user.dormant.info.none": "-(휴면정보 없음)",
  "user.employee.division": "부서",
  "user.employee.position": "직위",
  "user.employee.com.id.number": "사원번호",
  "user.employee.com.id.number.placeholder": "15자이하로 입력해주세요.",
  "user.meal.group": "식대그룹",
  "user.meal.group.help": "* 식대 그룹 변경시 사용자의 식대가 초기화 됩니다.",
  "user.welfare.group": "복지그룹",
  "user.welfare.group.help": "* 복지 그룹 변경시 사용자의 복지포인트가 초기화 됩니다.",
  "management.user": "사용자 관리",
  "management.user.permission.notice": "[NOTICE] 현재 사용자는 생성, 수정, 삭제 권한이 없습니다. 필요시, 회사 담당자에게 문의해주세요.",
  "management.user.dormant": "휴면 사용자 관리",
  "management.user.myInfo": "내정보 관리",
  "management.user.add": "사용자 추가",
  "management.user.modify": "사용자 정보 수정",
  "management.user.desc.required": "* 표시 항목은 필수 입력 입니다.",
  "management.user.individual": "개인정보",
  "management.user.service": "서비스 정보",
  "management.user.employee": "임직원정보",
  "management.user.meal": "식권대장 정보",
  "management.user.welfare": "복지대장 정보",
  "management.user.password.reset": "비밀번호 초기화",
  "management.user.status.inactive": "계정 일시정지",
  "management.user.status.withdraw": "계정 탈퇴",
  "management.user.captain.payments.permission": "대장마켓플레이스 권한",
  "user.captain.payments.permission": "관리자 권한",
  "user.captain.payments.permission.desc": "대장마켓플레이스의 관리 권한",
  "user.meal.permission": "식권대장 권한",
  "user.meal.permission.desc": "식권대장 서비스 내에서 서비스의 이용 권한",
  "user.quick.permission": "퀵대장 권한",
  "user.welfare.permission": "복지대장 권한",
  "user.quick.permission.desc": "퀵대장 서비스 내에서 서비스의 이용 권한",
  "user.company.permission.denied": "회사에서 서비스를 이용하지 않습니다.",

  "modified.delete": "삭제",
  "update": "수정",
  "update.confirm": "수정 하시겠습니까?",
  "delete": "삭제",
  "delete.complete": "삭제되었습니다.",
  "copy": "복사",
  "auth": "권한",

  "company.info": "회사정보",

  "buisnessman.info": "고객회사 기준 정보",
  "calculate.condition": "정산 기준 정보",
  "contract.info": "입금 기준 정보",

  "company.serial": "등록번호",
  "company.name": "법인명(단체명)",
  "company.presidentname": "대표자",
  "company.type": "종목",
  "company.condition": "업태",
  "company.notice": "회사 공지사항",
  "company.pushmessage": "사용자 푸시메시지 발송",
  "stat": "통계",
  "quick.totalAcount": "총 이용 건 수",
  "quick.totalAmount": "운임총합",

  "balance.method": "정산방법",
  "balance.proofmethod": "세금계산서 발행방식",
  "balance.proofwritedate": "세금계산서 작성일자",
  "balance.period": "정산구간",
  "balance.deposite": "대금 입금일",
  "balance.email.check": "세금계산서 수취 email",
  "balance.email.charge": "정산정보 수취 email",

  "contract.date": "계약일",
  "contract.startdate": "서비스 시작일",
  "contract.enddate": "서비스 종료일",
  "contract.vat": "부가세",
  "contract.feebysales": "거래금액대비 사용료",
  "contract.feebyuser": "인당 월사용료",
  "contract.monthlyfee": "기본 월사용료",

  "quick.fast.help": "기본 운임 2배 적용",
  "quick.company.passenger.help": "물품 배송 확인 목적으로 1인에 한해 허용 (오토바이 이외 차량만 해당)",
  "quick.address.add.complete": "주소록에 추가 되었습니다.",

  "navigate.before": "이전으로",

  "welfare.start.button": "복지대장 시작하기",
  "welfare.exceldownload": "엑셀 다운로드 내역",
  "welfare.point": "복지포인트",
  "welfare.point.give.deduct": "복지포인트 지급/차감내역",
  "welfare.point.give.deduct.task": "복지포인트 지급/차감",
  "welfare.point.give.deduct.by.excel": "엑셀파일로 복지포인트 지급/차감",
  "group.name": "그룹명",
  "welfare.give.name": "신청자",
  "welfare.give.register": "신청일자",
  "welfare.give.execute": "지급/차감일자",
  "welfare.give.total.count": "총 인원",
  "welfare.give.success.count": "성공",
  "welfare.give.fail.count": "실패",
  "welfare.give.cause": "사유",
  "managementByExcel": "엑셀파일로 관리하기",
  "welfare.given.header": "복지포인트 거래 내역",
  "welfare.remaining.header": "사용자별 잔여 복지포인트",
  "welfare.history.user.header": "사용자별 복지포인트 사용통계",
  "welfare.policy.header": "우리회사 복지정책",
  "welfare.store.header": "사용처 통계",

  "welfare.slogan.desc.01": "온/오프라인 200만여 개 사용처, 만족도 높은 진짜 복지",
  "welfare.slogan.desc.02": "이제 Npay 포인트로 복지하세요",
  "service.application": "서비스 신청",
  "download.service.introduction": "서비스 소개서 다운로드",
  "service.paymentMethod.placeholder": "지급방식을 선택해 주세요.",
  "service.email.placeholder": "이메일 주소를 입력해 주세요.",
  "service.amount.placeholder": "금액을 입력해 주세요."
}
